import React, { useEffect, useRef, useState } from 'react';
import PropTypes, { element } from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { NavBar, Svg, Icon, IconButton, Dropdown } from '../';
import { Menubar } from 'primereact/menubar';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Dropdown as DropdownPF } from 'primereact/dropdown';
import { TieredMenu } from 'primereact/tieredmenu';
import BackgroundColor from '../../pages/Colors/BackgroundColor';
import { utilities as csToolsUtils } from '@cornerstonejs/tools';


function Header({
  children,
  menuOptions,
  isReturnEnabled,
  onClickReturnButton,
  isSticky,
  WhiteLabeling,
  positionMenu,
  setPositionMenu,
  ...props
}): ReactNode {

  const { t } = useTranslation('Header');

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const ocultarBtnAslEBaixar = (memoPositionMenu) => {
    const buttons = ['btnAslViewer', 'btnDownload'];
    buttons.forEach(button => {
      document.getElementById(button).style.display = memoPositionMenu === "1" ? 'none' : '';
    });
  }

  const setStatePositionMenu = (newPositionMenu) => {
    try {
      //      positionMenu = positionMenu === undefined ? window.isMobile() ? 0 : 0 : positionMenu;
      //if (newPositionMenu !== positionMenu)
      setPositionMenu(newPositionMenu);
    } catch (ex) { }
  }

  const getPositionMenu = () => {
    try {
      const memoPositionMenu = localStorage.getItem('positionMenu');
      if (memoPositionMenu) {
        ocultarBtnAslEBaixar(memoPositionMenu);
        const _positionMenu = JSON.parse(memoPositionMenu);
        setStatePositionMenu(_positionMenu);
        return _positionMenu;
      }
    } catch (ex) { }
    return 0;
  }

  const menu = useRef(null);
  const [optionsMenuHeader, setOptionsMenuHeader] = useState([]);
  const autenticado = JSON.parse(sessionStorage.getItem('auth')) !== null;
  const [dialogSobre, setDialogSobre] = useState(false);
  const [dialogConfirmacao, setDialogConfirmacao] = useState(false);
  const [textoMenu, setTextoMenu] = useState('Horizontal');
  const [countMenuPosition, setCountMenuPosition] = useState(getPositionMenu());
  const [acessoTmtv] = useState(window.location.href.indexOf("tmtv") > 0);
  const [acessoViewer] = useState(window.location.href.indexOf("viewer") > 0);
  const [selectedOptionMobile, setSelectedOptionMobile] = useState(null);

  useEffect(() => {
    if (window.isMobile() === false) {
      if (optionsMenuHeader.length === 0)
        autenticado ? menuAdm() : menuClient();
    }
    startPositionMenu('init');
  }, [optionsMenuHeader])

  const imprimirImagem = () => {
    const paciente = document.getElementById('top-pacienteNome').innerText;
    const exame = document.getElementById('top-exame').innerText;
    const cornerstoneCanvas = document.body.getElementsByClassName('cornerstone-canvas');
    const widthImg = `${cornerstoneCanvas.length > 1 ? (98.9 / 2) : 100}%`;
    let imagens = "";
    var cnt = 0;
    for (let index = 0; index < cornerstoneCanvas.length; index++) {
      if (cornerstoneCanvas[index]) {
        imagens += `<img src="${cornerstoneCanvas[index].toDataURL()}" Width="${widthImg}" /> `;
        cnt++;
        if (cnt == 2) {
          imagens += '<br>';
          cnt = 0;
        }
      }
    }
    var win = window.open('about:blank', "_new");
    win.document.open();
    win.document.write([
      '<html>',
      '   <head>',
      '   <title>Tztion WebViewer</title>',
      '   </head>',
      '   <body onload="window.print()" onafterprint="window.close()">',
      '   </br>',
      `   <strong>${paciente}</strong>`,
      `   ${exame}</br></br>`,
      imagens,
      //`   </br></br><div style="text-align:right">${sessionStorage.getItem('versao')}</div>`,
      '   </body>',
      '</html>'
    ].join(''));
    win.document.close();
  }

  const btnImprimir = {
    title: "Imprimir",
    icon: "print",
    onClick: () => {
      imprimirImagem();
    },
    style: { display: acessoViewer ? '' : 'none' }
  };

  const btnListaExames = {
    title: "Listar Exames",
    icon: "list-bullets",
    onClick: () => {
      window.location.href = window.location.origin;
    }
  };

  const btnPreferencias = {
    title: t('Preferences'),
    icon: "user",
    onClick: () => {
      menuOptions[1].onClick();
    }
  };

  const btnSobre = {
    title: "Sobre",
    icon: "info",
    onClick: () => {
      setDialogSobre(true);
    }
  };

  const menuClient = () => {
    const optionsValue = window.isMobile() === false ? [
      btnImprimir,
      btnPreferencias,
      btnSobre
    ] : [];
    if (optionsValue !== optionsMenuHeader)
      setOptionsMenuHeader(optionsValue);
  }

  const menuAdm = () => {
    let optionsValue = [];
    if (acessoViewer)
      optionsValue.push(btnImprimir, btnListaExames)
    optionsValue.push(btnPreferencias, btnSobre);
    setOptionsMenuHeader(optionsValue);
  }

  const animeMenu = (elDivMenu) => {
    elDivMenu.style.opacity = '0';
    setTimeout(() => {
      elDivMenu.style.opacity = '1';
    }, 500);
  }

  const savePositionMenu = (position) => {
    setStatePositionMenu(position);
    localStorage.setItem('positionMenu', position);
  }

  const startPositionMenu = (start) => {

    if (!isReturnEnabled)
      return;

    try {
      start = start === 'init';

      let countPosition = start ? countMenuPosition : countMenuPosition + 1;

      if (countPosition > 2)
        countPosition = 0;

      if (window.isMobile())
        countPosition = 0;

      setCountMenuPosition(countPosition);
      savePositionMenu(countPosition);

      const elDivMain = document.getElementById('divMain');
      const elMenuContainer = document.getElementById('divMenuContainer');
      const elMenuHorizontal = document.getElementById('menuHorizontal');
      const elMenuVertical = document.getElementById('menuVertical');
      const elDivToolBar = document.getElementById('divToolBar');
      const elDivPanel = document.getElementById('divPanel');

      if (countPosition === 1) {
        elDivMain.classList.add('flex');
        elDivToolBar.classList.remove('flex');
        elMenuContainer.classList.remove('layout-menu-container-b');
        elMenuContainer.classList.remove('layout-menu-container-h');
        elMenuContainer.classList.add('layout-menu-container-v');
        elMenuVertical.append(elMenuContainer);
        elDivPanel.style.height = 'calc(100vh - 70px)';
        elDivPanel.style.transition = 'height 0.5s ease 0s !important';
        setTextoMenu('Vertical');
        animeMenu(elMenuContainer);
        return;
      }

      if (countPosition === 0 || countPosition === 2) {
        elDivMain.classList.remove('flex');
        elDivToolBar.classList.add('flex');
        elMenuContainer.classList.remove('layout-menu-container-v');
        elMenuContainer.style.marginBottom = '10';
        elMenuContainer.classList.remove('layout-menu-container-b');
        elMenuContainer.classList.add('layout-menu-container-h');
        elMenuHorizontal.append(elMenuContainer);
        elDivPanel.style.height = 'calc(100vh - 140px)';
        elDivPanel.style.transition = 'height 0.5s ease 0s !important';
        setTextoMenu('Horizontal');
        elMenuHorizontal.removeAttribute('style');
        animeMenu(elMenuContainer);
      }

      if (countPosition === 2) {
        elMenuHorizontal.style.opacity = '0';
        elMenuContainer.style.marginBottom = '0';
        elMenuHorizontal.style.position = 'absolute';
        elMenuHorizontal.style.zIndex = '9999';
        elMenuHorizontal.style.bottom = '0';
        elMenuHorizontal.style.width = '100%';
        elMenuContainer.classList.remove('layout-menu-container-h');
        elMenuContainer.classList.add('layout-menu-container-b');
        setTextoMenu('Bottom');
        animeMenu(elMenuHorizontal);
      }

    } catch (ex) {
      console.log(ex);
    }
  }

function abrirSerieHorizontal() {
    const id = 'modalSerieHorizontal';
    const modal = document.createElement('div');
    modal.id = id;
    modal.className =
      'fixed top-16 left-1/2 -translate-x-1/2 bg-[#161618]/95 rounded-xl shadow-lg z-[9998] transition-all duration-300 ease-in-out p-4 flex flex-col backdrop-blur-sm';
    modal.style.width = '100%';
    modal.style.minWidth = '100%';
    modal.style.maxHeight = '80vh';
    modal.style.overflowY = 'auto';

    // 🔹 Container horizontal
    const newContainer = document.createElement('div');
    newContainer.id = 'newContainerThumb';
    newContainer.style.display = 'flex';
    newContainer.style.flexDirection = 'row';
    newContainer.style.gap = '8px';
    newContainer.style.overflowX = 'scroll'; // sempre visível
    newContainer.style.whiteSpace = 'nowrap';
    newContainer.style.padding = '8px';
    newContainer.style.border = 'none';
    newContainer.style.outline = 'none';
    newContainer.style.boxShadow = 'none';
    newContainer.style.cursor = 'grab';
    newContainer.style.scrollbarWidth = 'auto'; // Firefox sempre mostra
    newContainer.style.scrollbarColor = 'rgba(255,255,255,0.3) transparent';

    // 🔹 Estilo da barra no Chrome/Safari
    newContainer.innerHTML += `
      <style>
        #${newContainer.id}::-webkit-scrollbar {
          height: 8px;
        }
        #${newContainer.id}::-webkit-scrollbar-track {
          background: rgba(255,255,255,0.05);
        }
        #${newContainer.id}::-webkit-scrollbar-thumb {
          background-color: rgba(255, 255, 255, 0.3);
          border-radius: 4px;
        }
      </style>
    `;

    // 🔹 Ajuste das thumbs
    const thumbs = document.querySelectorAll(
      '[class="flex flex-row flex-1 px-3 py-2 cursor-pointer outline-none thumbnail"]'
    );

    function handleThumbClick(thumbId) {
      let updatedViewports = [];
      const viewportIndex = window.services.viewportGridService.getState().activeViewportIndex;
      try {

        updatedViewports = window.services.hangingProtocolService.getViewportsRequireUpdate(
          viewportIndex,
          thumbId
        );
      } catch (error) {
        console.warn(error);
        window.services.uiNotificationService.show({
          title: 'Thumbnail Double Click',
          message: error.message,
          type: 'info',
          duration: 3000,
        });
      }

      window.services.viewportGridService.setDisplaySetsForViewports(updatedViewports);

      const modal = document.getElementById('modalSerieHorizontal');
      const existingLoader = document.getElementById('loadingOverlay');

      // Se o modal estiver aberto, fecha ele
      if (modal) {
        modal.remove();
        if (existingLoader) existingLoader.remove();
        return;
      }
    }

    thumbs.forEach((thumb, index) => {
      thumb.style.position = 'relative'; // precisa pra posicionar o número
      thumb.style.border = '1px solid #2c2c2c'; // borda discreta
      thumb.style.borderRadius = '6px';
      thumb.style.overflow = 'hidden';
      thumb.style.width = '120px';
      thumb.style.height = '120px';
      thumb.style.flex = '0 0 auto'; // mantém o formato quadrado fixo
      thumb.style.backgroundColor = '#1b1b1e';

      const img = thumb.querySelector('img');
      if (img) {
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'cover';
        img.style.display = 'block';
      }

      // 🔹 Cria o número da thumb
      const numero = document.createElement('div');
      numero.textContent = thumb.querySelector('[class="mr-4"]')?.textContent || '';
      numero.style.position = 'absolute';
      numero.style.top = '4px';
      numero.style.left = '6px';
      numero.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
      numero.style.color = 'white';
      numero.style.fontSize = '12px';
      numero.style.fontWeight = '500';
      numero.style.padding = '2px 5px';
      numero.style.borderRadius = '4px';
      numero.style.pointerEvents = 'none'; // não atrapalha clique na thumb
      thumb.appendChild(numero);

      // 🔹 Cria a descrição da thumb
      const descricao = document.createElement('div');
      descricao.textContent = thumb.querySelector('.text-base.text-white.break-all')?.textContent || '';
      descricao.style.position = 'absolute';
      descricao.style.bottom = '4px';
      descricao.style.left = '6px';
      descricao.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
      descricao.style.color = 'white';
      descricao.style.fontSize = '12px';
      descricao.style.fontWeight = '500';
      descricao.style.padding = '2px 5px';
      descricao.style.borderRadius = '4px';
      thumb.appendChild(descricao);

      let thumbId = thumb.id;
      thumb.addEventListener('click', () => handleThumbClick(thumbId.replace('thumbnail-', '')));
    });


    // 🔹 Esconde os boxes originais
    const boxes = document.querySelectorAll('[class="flex flex-col items-center flex-2"]');
    boxes.forEach((box) => (box.style.display = 'none'));
    thumbs.forEach((thumb) => newContainer.appendChild(thumb));

    // 🔹 Adiciona as thumbs depois dos botões
    modal.appendChild(newContainer);

    // 🔹 Adiciona no body
    document.body.appendChild(modal);

    // 🔹 Fecha a lista original
    const btnClose = document.querySelector('[data-cy="seriesList-btn"]');
    if (btnClose) btnClose.click();

    // 🔹 Fecha clicando fora do modal
    setTimeout(() => {
      window.addEventListener(
        'click',
        function outsideClick(e) {
          if (!modal.contains(e.target)) {
            modal.remove();
            window.removeEventListener('click', outsideClick);
          }
        },
        { once: true }
      );
    }, 100);
}


const onChangeOptioDropdownMobile = (side) => {
  try {
    const modal = document.getElementById('modalSerieHorizontal');
    const existingLoader = document.getElementById('loadingOverlay');

    // Se o modal estiver aberto, fecha ele
    if (modal) {
      modal.remove();
      if (existingLoader) existingLoader.remove();
      return;
    }

    const loader = document.createElement('div');
    loader.id = 'loadingOverlay';
    loader.style.position = 'fixed';
    loader.style.top = '0';
    loader.style.left = '0';
    loader.style.width = '100vw';
    loader.style.height = '100vh';
    loader.style.backgroundColor = 'rgba(22, 22, 24, 1)'; // mesmo fundo, só que translúcido
    loader.style.zIndex = '9997';
    loader.style.display = 'flex';
    loader.style.alignItems = 'center';
    loader.style.justifyContent = 'center';
    loader.style.backdropFilter = 'blur(4px)';
    loader.style.transition = 'opacity 0.3s ease';

    loader.innerHTML = `
      <div style="
        width: 40px;
        height: 40px;
        border: 4px solid rgba(255,255,255,0.2);
        border-top-color: rgba(255,255,255,0.8);
        border-radius: 50%;
        animation: spin 1s linear infinite;
      "></div>

      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    `;

    document.body.appendChild(loader);

    document.querySelector(`[data-cy=side-panel-header-${side}]`).click();

    const interval = setInterval(() => {
      const thumbs = document.querySelectorAll(
        '[class="flex flex-row flex-1 px-3 py-2 cursor-pointer outline-none thumbnail"]'
      );

      if (thumbs.length > 0) {
        clearInterval(interval);
        abrirSerieHorizontal();
        loader.style.opacity = '0';
        setTimeout(() => loader.remove(), 300);
      }
    }, 1000);
  } catch (ex) {
    console.error('Erro no onChangeOptioDropdownMobile:', ex);
  }
};


  const optionsDropdownMobile = [
    {
      name: 'Estudos',
      onClick: () => onChangeOptioDropdownMobile('left')
    },
    {
      name: 'Segmentação',
      onClick: () => onChangeOptioDropdownMobile('right')
    },
    {
      name: 'Medidas',
      onClick: () => onChangeOptioDropdownMobile('right')
    },
    {
      name: 'Laudo',
      onClick: () => onChangeOptioDropdownMobile('right')
    },
  ];

  const onChangeOptionsMobile = (value) => {
    setSelectedOptionMobile(value);
  }

  const getActualSerieNumber = () => {

  }

  useEffect(() => {
    if (selectedOptionMobile) {
      selectedOptionMobile.onClick();
    }
  }, [selectedOptionMobile])

  const getEnabledElemets = () => {
    const enabledElements = cornerstone.getEnabledElements();
    if (enabledElements.length === 0)
      return;
    return enabledElements;
  }
  
  const jumpToImage = (action) => {

    const viewportIndex = window.services.viewportGridService.getState().activeViewportIndex;

    const enabledElements = getEnabledElemets();
    const viewport = enabledElements[viewportIndex].viewport;

    let imageIndex = 0;
    if (action === 'next') {
      imageIndex = viewport.currentImageIdIndex + 1;
    }
    else {
      imageIndex = viewport.currentImageIdIndex - 1;
    }
    
    csToolsUtils.jumpToSlice(viewport.element, {
      imageIndex,
      debounceLoading: true,
    });
  };

  const menuStartMobile = (
      <div
        id="mobile-header-xray"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: '#161618',
          height: '60px',
          padding: '0 10px',
          color: '#fff',
        }}
      >
        <div
      className="pagination-controls"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '8px',
        backgroundColor: '#161618',
        padding: '6px 10px',
        borderRadius: '6px',
        border: '1px solid #333',
      }}
    >
      <span
        className="Serie"
        style={{
          color: '#ffffff',
          fontSize: '1rem',
          fontWeight: 500,
          lineHeight: 1.2,
          paddingRight: '10px',
          borderRight: '1px solid #444',
          flexGrow: 1,
          textAlign: 'left',
        }}
      >
        Série
      </span>

      <button
        className="arrow-button"
        aria-label="Próximo"
        onClick={() => onChangeOptioDropdownMobile('left')}
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            color: '#ffffff',
            strokeWidth: 3.5,
          }}
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
    </div>
    
    {/* Botão Central - Navegação de imagens (Controle de Paginação) - MANTIDO */}
    <div
      id="viewer-navigation"
      style={{
        textAlign: 'center',
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', 
        marginLeft: '5px'
      }}
    >
      <div 
        className="pagination-controls"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          backgroundColor: '#161618',
          padding: '6px 10px',
          borderRadius: '6px',
          border: '1px solid #333', // Borda
        }}
      >
        {/* Botão Anterior */}
        <button 
          className="arrow-button" 
          aria-label="Anterior"
          onClick={() => jumpToImage('previous')}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20"
            height="20"
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              color: '#ffffff',
              strokeWidth: 3.5,
            }}
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>

        {/* Contador de Página */}
        <span 
          className="page-counter"
          style={{
            color: '#ffffff',
            fontSize: '1rem',
            fontWeight: 500,
            lineHeight: 1.2,
            padding: '0 10px',
            borderLeft: '1px solid #444',
            borderRight: '1px solid #444',
          }}
        >
          {currentImageIndex}/47
        </span>

        {/* Botão Próximo */}
        <button 
          className="arrow-button" 
          aria-label="Próximo"
          onClick={() => jumpToImage('next')} // Exemplo de navegação para a próxima imagem na viewport 0
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
            margin: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20"
            height="20"
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            style={{
              color: '#ffffff',
              strokeWidth: 3.5,
            }}
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  </div>
);

  const menuStart = window.isMobile() ? menuStartMobile : <div style={{ display: 'flex' }}>
    <a href={window.location.origin}><img alt="logo" src="/layout/logo.png" style={{ maxHeight: '40px' }} className="p-mr-2"></img></a>
    <Dropdown id="options" size="150px" showDropdownIcon={false} list={optionsMenuHeader}>
      <IconButton
        id={'options-settings-icon'}
        variant="text"
        color="inherit"
        className="text-primary-active"
      >
        <Icon name="menu-top" />
      </IconButton>
    </Dropdown>
  </div>

  const menuEnd = window.isMobile() ?         
  <div
      className="pagination-controls2"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '8px',
        backgroundColor: '#161618',
        padding: '6px 10px',
        borderRadius: '6px',
        border: '1px solid #333',
      }}
    >
      <span
        className="Acoes"
        style={{
          color: '#ffffff',
          fontSize: '1rem',
          fontWeight: 500,
          lineHeight: 1.2,
          paddingRight: '10px',
          borderRight: '1px solid #444',
          flexGrow: 1,
          textAlign: 'left',
        }}
      >
        Ações
      </span>

      <button
        id='btnOptionMobile'
        className="arrow-button"
        aria-label="Próximo"
        style={{
          backgroundColor: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: 0,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            color: '#ffffff',
            strokeWidth: 3.5,
          }}
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
    </div> 
    :  
    <div>
      <div className="flex items-center">{children}</div>
      <Button
        label={<div className='flex'>
          <Icon name={`align-menu-${textoMenu.toLowerCase()}`} style={{ width: '20px', height: '20px', color:'#ffffff' }} />
          <div style={{ marginLeft: '10px' }}>Posição do Menu</div>
        </div>}
        onChange={(e) => setValue(e.value)}
        style={{ display: window.isMobile() || !isReturnEnabled ? 'none' : '', color:'#ffffff' }}
        tooltipOptions={{ 'position': 'bottom' }}
        onClick={(e) => startPositionMenu(e)}
        className="p-button-text"
      >
      </Button>

      <Button
        label={`Fechar${window.isMobile() === false ? ' Exame' : ''}`}
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => FecharExame()}
        style={{ display: ((sessionStorage.getItem('auth') && sessionStorage.getItem('lastWorklistUrl')) && (acessoViewer || acessoTmtv) ? '' : 'none'), color:'#ffffff' }}
      />
      <Button
        style={{ marginLeft: '8px', color:'#ffffff' }}
        label='Sair'
        icon="pi pi-sign-out"
        className="p-button-text"
        onClick={() => setDialogConfirmacao(true)}
      />
    </div>;

  const renderFooter = <div style={{ textAlign: 'right' }}>
    <Button style={{color:'#ffffff'}} label="Sim" icon="pi pi-check" onClick={() => sair()} autoFocus />
    <Button style={{color:'#ffffff'}} label="Não" icon="pi pi-times" onClick={() => setDialogConfirmacao(false)} className="p-button-text" />
  </div>

  const sair = () => {
    if (sessionStorage.getItem('auth')) {
      sessionStorage.clear();
      sessionStorage.setItem('redirectUser', '1');
    } else {
      sessionStorage.setItem('redirectMsg', '1');
    }
    setTimeout(() => {
      window.location.href = window.location.origin;
    }, 500);
  }

  const FecharExame = () => {
    window.location.href = sessionStorage.getItem('lastWorklistUrl');
  }

  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  return (
    <>
      <Dialog
        header="Sobre"
        visible={dialogSobre}
        style={{ width: isMobile ? '80vw' : '40vw' }}
        onHide={() => setDialogSobre(false)}
        draggable={false}
        resizable={false}
      >
        <p><strong>Tzion WebViewer</strong></p>
        <p>O Tzion WebViewer possui funcionalidades avançadas como manipulação de imagem (panorâmica, zoom, janelas, predefinições, rotação, flip, rolagem, mira, filtragem), comparação de séries ou estudos, sincronização em série, reconstruções multiplanares e projeção de intensidade máxima entre outras funcionalidades que permitem um diagnóstico por imagem ainda mais assertivo.</p>
        <br></br>
        <div className='flex'>
          <div>
            <img alt="logo" src="/assets/logo-asl.png" width="85" height="85"></img>
          </div>
          <div style={{ marginLeft: '30px' }}>
            ASL SOFTHOUSE<br></br>
            Contato: +55 21 2742 8080<br></br>
            <a href="https://aslsofthouse.com.br">https://aslsofthouse.com.br</a> <br></br>
            <a href="mailto:contato@aslsofthouse.com.br">contato@aslsofthouse.com.br</a>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <br></br>
          <p>{window.config.versao}</p>
        </div>
      </Dialog>

      <Dialog
        header="Confirmação"
        visible={dialogConfirmacao}
        style={{ width: '25vw' }}
        //footer={renderFooter}
        position={'top'}
        onHide={() => setDialogConfirmacao(false)}
        draggable={false}
        resizable={false}
      >
        <br></br>
        <div style={{ textAlign: 'center' }}><p>Tem certeza que deseja sair da aplicação?</p></div><br></br>
        <br></br>
        {renderFooter}
      </Dialog >

      <Menubar
        model={[]}
        start={menuStart}
        end={menuEnd}
        style={{ border: 'none', borderRadius: '0', background: '#161618' }}
      ></Menubar>

    </>

  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
};

Header.defaultProps = {
  isReturnEnabled: true,
  isSticky: false,
};

export default Header;
